import { render, staticRenderFns } from "./ManageCloud.vue?vue&type=template&id=4654dac0&scoped=true&"
import script from "./ManageCloud.vue?vue&type=script&lang=js&"
export * from "./ManageCloud.vue?vue&type=script&lang=js&"
import style0 from "./ManageCloud.vue?vue&type=style&index=0&id=4654dac0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4654dac0",
  null
  
)

export default component.exports